export const useLocalStorage = (key) => {
  const setItem = async (value = null) => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (err) {
      console.error(err);
    }
  };

  const getItem = async () => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (err) {
      console.error(err);
    }
  };

  const removeItem = async () => {
    try {
      window.localStorage.removeItem(key);
    } catch (err) {
      console.error(err);
    }
  };

  return { setItem, getItem, removeItem };
};
